module.exports = __webpack_public_path__ + "img/passport_seria_old.aefeb069.png";